/**
 * FAQ Accordion
 * Vanilla JS handler for FAQ section accordion behavior.
 * Supports single-open mode and smooth height animations.
 * Uses aria-expanded for accessibility.
 */
(function () {
  'use strict';

  function initFaqAccordion() {
    var containers = document.querySelectorAll('[data-faq-accordion]');
    if (!containers.length) return;

    containers.forEach(function (container) {
      var singleOpen = container.getAttribute('data-single-open') === 'true';
      var items = container.querySelectorAll('[data-faq-item]');

      items.forEach(function (item) {
        var trigger = item.querySelector('[data-faq-trigger]');
        var answer = item.querySelector('[data-faq-answer]');
        if (!trigger || !answer) return;

        trigger.addEventListener('click', function () {
          var isOpen = trigger.getAttribute('aria-expanded') === 'true';

          if (singleOpen) {
            closeAllItems(container, item);
          }

          if (isOpen) {
            closeItem(item, trigger, answer);
          } else {
            openItem(item, trigger, answer);
          }
        });
      });
    });
  }

  /**
   * Open an accordion item with smooth height animation.
   */
  function openItem(item, trigger, answer) {
    trigger.setAttribute('aria-expanded', 'true');
    item.classList.add('faq__item--open');

    // Remove hidden to enable measurement
    answer.hidden = false;
    answer.style.visibility = 'visible';

    // Measure the content height
    var inner = answer.querySelector('.faq__answer-inner');
    var targetHeight = inner ? inner.offsetHeight : answer.scrollHeight;

    // Set explicit max-height for transition
    answer.style.maxHeight = '0px';
    answer.style.opacity = '0';

    // Force reflow
    answer.offsetHeight; // eslint-disable-line no-unused-expressions

    // Animate open
    answer.style.maxHeight = targetHeight + 'px';
    answer.style.opacity = '1';

    // After transition, remove inline max-height so content can reflow
    var onTransitionEnd = function (e) {
      if (e.propertyName === 'max-height') {
        answer.style.maxHeight = 'none';
        answer.removeEventListener('transitionend', onTransitionEnd);
      }
    };
    answer.addEventListener('transitionend', onTransitionEnd);
  }

  /**
   * Close an accordion item with smooth height animation.
   */
  function closeItem(item, trigger, answer) {
    trigger.setAttribute('aria-expanded', 'false');

    // Set current height explicitly before transitioning to 0
    answer.style.maxHeight = answer.scrollHeight + 'px';
    answer.style.opacity = '1';

    // Force reflow
    answer.offsetHeight; // eslint-disable-line no-unused-expressions

    // Animate closed
    answer.style.maxHeight = '0px';
    answer.style.opacity = '0';

    var onTransitionEnd = function (e) {
      if (e.propertyName === 'max-height') {
        item.classList.remove('faq__item--open');
        answer.hidden = true;
        answer.style.visibility = 'hidden';
        answer.removeEventListener('transitionend', onTransitionEnd);
      }
    };
    answer.addEventListener('transitionend', onTransitionEnd);
  }

  /**
   * Close all items in a container except the excluded one.
   */
  function closeAllItems(container, excludeItem) {
    var items = container.querySelectorAll('[data-faq-item]');
    items.forEach(function (item) {
      if (item === excludeItem) return;

      var trigger = item.querySelector('[data-faq-trigger]');
      var answer = item.querySelector('[data-faq-answer]');
      if (!trigger || !answer) return;

      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      if (isOpen) {
        closeItem(item, trigger, answer);
      }
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFaqAccordion);
  } else {
    initFaqAccordion();
  }
})();
